export const DEFAULT_URLS = {
  TERMS_OF_USE: 'https://kyc.datascouts.eu/terms',
  PRIVACY_POLICY: 'https://datascouts.eu/privacy-statement/',
  COOKIE_POLICY: 'https://datascouts.eu/cookie-policy/',
  FAQ: 'https://www.datascouts.eu/faq',
}
